module.exports = __webpack_public_path__ + "img/1543853805.8e4f6dbd.jpg";